import { resolveComponent as _resolveComponent, createVNode as _createVNode, withKeys as _withKeys, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-00252b28")

_pushScopeId("data-v-00252b28")
const _hoisted_1 = { class: "carrier" }
const _hoisted_2 = { class: "control-bar" }
const _hoisted_3 = { class: "search-wrap" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 查询物流 ")
const _hoisted_5 = { class: "table" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_PageHeader = _resolveComponent("PageHeader")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_link = _resolveComponent("el-link")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_Table = _resolveComponent("Table")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("header", null, [
      _createVNode(_component_PageHeader, { title: "承运商列表" })
    ]),
    _createVNode("main", null, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode(_component_el_input, {
            placeholder: "请输入承运商编号或名称",
            modelValue: _ctx.keyword,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.keyword = $event)),
            class: "input-with-select",
            size: "small",
            style: {"width":"350px"},
            onKeyup: _withKeys(_ctx.search, ["enter"])
          }, {
            append: _withId(() => [
              _createVNode(_component_el_button, {
                size: "medium",
                icon: "el-icon-search",
                onClick: _ctx.search
              }, null, 8, ["onClick"])
            ]),
            _: 1
          }, 8, ["modelValue", "onKeyup"])
        ]),
        _createVNode(_component_el_link, {
          href: "https://www.17track.net/zh-cn",
          target: "_blank",
          type: "primary"
        }, {
          default: _withId(() => [
            _hoisted_4
          ]),
          _: 1
        })
      ]),
      _createVNode("div", _hoisted_5, [
        _createVNode(_component_Table, {
          data: _ctx.tableList,
          loading: _ctx.loading,
          pagination: _ctx.pagination,
          onCurrentChange: _ctx.pageChange
        }, {
          default: _withId(() => [
            _createVNode(_component_el_table_column, {
              label: "承运商中文名称",
              prop: "courier_name_cn"
            }),
            _createVNode(_component_el_table_column, {
              label: "承运商英文名称",
              prop: "courier_name"
            }),
            _createVNode(_component_el_table_column, {
              label: "承运商编号",
              prop: "courier_code"
            }),
            _createVNode(_component_el_table_column, {
              label: "物流公司主页",
              prop: "courier_homepage"
            })
          ]),
          _: 1
        }, 8, ["data", "loading", "pagination", "onCurrentChange"])
      ])
    ])
  ]))
})